import config from "../../config.js";
import axios from "axios";
export const handleApiError = (error, context = "") => {
  if (error.response) {
    console.warn(
      `${context} → API responded with status ${error.response.status}`,
      error.response.data
    );
  } else if (error.request) {
    console.error(
      `${context} → No response received from server`,
      error.request
    );
  } else {
    console.error(`${context} → Request setup error`, error.message);
  }
};

export const getAllVehicles = async () => {
  try {
    const resp = await axios.get(`${config.baseURL}/vehicle/organization`, {
      withCredentials: true,
    });
    return resp.data;
  } catch (error) {
    handleApiError(error, "getAllVehicles");
    return [];
  }
};

export const getAllRoutes = async () => {
  try {
    const resp = await axios.get(`${config.baseURL}/route/organization`, {
      withCredentials: true,
    });
    return resp.data;
  } catch (error) {
    handleApiError(error);
    return [];
  }
};

export const getAllStops = async () => {
  try {
    const resp = await axios.get(`${config.baseURL}/stop/organization`, {
      withCredentials: true,
    });
    return resp.data;
  } catch (error) {
    handleApiError(error);
    return [];
  }
};

// Fetch cached direction for a single deviceId
export const getVehicleDirection = async (deviceId) => {
  try {
    const response = await axios.get(
      `${config.baseURL}/vehicle/direction/${deviceId}`,
      {
        withCredentials: true,
      }
    );
    return response.data.direction || "unknown";
  } catch (error) {
    if (error.response && error.response.status === 404) {
      console.info(
        `No cached direction found for deviceId ${deviceId} → returning "unknown"`
      );
      return "unknown"; // fallback instead of null
    }
    handleApiError(error, `getVehicleDirection(${deviceId})`);
    return "unknown";
  }
};

// Update direction in cache for a deviceId
export const updateVehicleDirection = async (deviceId, direction) => {
  try {
    const response = await axios.post(
      `${config.baseURL}/vehicle/update-direction`,
      { deviceId, direction },
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    handleApiError(error, `updateVehicleDirection(${deviceId})`);
    // Either swallow:
    return null;
    // Or rethrow only if you must halt the caller:
    // throw error;
  }
};

// change this Naveed
// Pass orgId explicitly and remove withCredentials
export const getVehiclesByOrgIdIndependent = async (organizationId) => {
  try {

    const resp = await axios.get(
      `${config.baseURL}/vehicle/organization/independent/${organizationId}` // Or use ?organizationId=${organizationId}
    );
    return resp.data;
  } catch (error) {
    handleApiError(error, "getVehiclesByOrgId");
    return [];
  }
};

export const getRoutesByOrgIdIndependent = async (organizationId) => {
  try {

    const resp = await axios.get(
      `${config.baseURL}/route/organization/independent/${organizationId}`
    );
    return resp.data;
  } catch (error) {
    handleApiError(error, "getRoutesByOrgId");
    return [];
  }
};

export const getStopsByOrgIdIndependent = async (organizationId) => {
  try {

    const resp = await axios.get(
      `${config.baseURL}/stop/organization/independent/${organizationId}`
    );
    return resp.data;
  } catch (error) {
    handleApiError(error, "getStopsByOrgId");
    return [];
  }
};

export async function createAlert(payload) {

  try {
    const response = await fetch(`${config.baseURL}/alert`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // If you have auth → add:
        // "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.message || "Failed to create alert");
    }

    return await response.json();
  } catch (error) {
    console.error("❌ Error in createAlert fetch:", error);
    throw error;
  }
}

export async function createOffRouteAlert(vehicleId, orgId) {
  try {
    await createAlert({
      subject: "Vehicle Off-Route",
      body: `Vehicle ${vehicleId} has deviated from its route.`,
      alertType: "VEHICLE",
      medium: "SYSTEM",
      organizationId: orgId,
      vehicleId,
      alertStatus: "ACTIVE",
      statusFlag: "UNREAD",
    });
    console.log("🚨 Off-route alert created!");
  } catch (err) {
    console.error("❌ Failed to create off-route alert:", err);
  }
}
